import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode, toastError, toastSuccess} from "../../assets/functions";
import {useNavigate} from "react-router-dom";

export const setManagerBearerAuthorization = (token = null) => {
    const tempToken = "DGlHi!-nKHCuuy8#jh%SuWen01UTxaX4Ai-j%tTVaGNNd-wJ,0~Z,UMGMLx%1iTK" + "V$9bmPTccP%u;Oq!$98-*y#EX7JKt/l1un5bzEBP5nrnYFWDf*Teg-oYtF;iNU$F";
    localStorage.setItem("managerToken" , token || tempToken);
}

const getManagerBearerAuthorization = () => {
    return localStorage.getItem("managerToken");
}

export const getManagerHeader = () => {
    const token = getManagerBearerAuthorization();

    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    };
    return headers;
}

export const setReporterBearerAuthorization = (token = null) => {
    const tempToken = "DGlHi!-nKHCuuy8#jh%SuWen01UTxaX4Ai-j%tTVaGNNd-wJ,0~Z,UMGMLx%1iTK" + "V$9bmPTccP%u;Oq!$98-*y#EX7JKt/l1un5bzEBP5nrnYFWDf*Teg-oYtF;iNU$F";
    localStorage.setItem("reporterToken" , token || tempToken);
}

const getReporterBearerAuthorization = () => {
    return localStorage.getItem("reporterToken");
}
export const getReporterHeader = () => {
    const token = getReporterBearerAuthorization();

    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    };
    return headers;
}

export const isManagerLoggedIn = async () => {
    const headers = getManagerHeader();
    return axios.get(baseCmsApiUrl + 'authorization?role=MANAGER', {headers})
        .then((response) => {
            console.log(response)
            console.log(response.data)
            return true;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
            return false;
        }).finally(() => {

    })
}

export const isReporterLoggedIn = async () => {
    const headers = getReporterHeader();
    return axios.get(baseCmsApiUrl + 'authorization?role=REPORTER', {headers})
        .then((response) => {
            console.log(response)
            console.log(response.data)
            return true;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
            return false;
        }).finally(() => {

        })
}

export const login = async (loginForm) => {
    return axios.post(baseCmsApiUrl + 'login' , loginForm)
        .then((response) => {
            if (loginForm.role == "MANAGER")
                setManagerBearerAuthorization(response.data.token)
            else if (loginForm.role == "REPORTER")
                setReporterBearerAuthorization(response.data.token)

            toastSuccess(base64DecodeUnicode(response.statusText));
            return true;
        })
        .catch((e) => {
            toastError(base64DecodeUnicode(e.response.statusText))
            return false;
        }).finally(() => {

        })
}

export const logout = () => {
    localStorage.setItem("managerToken" , "");
    localStorage.setItem("reporterToken" , "");

}
